var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class Cart {
    static find(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return window.axios
                .get(Cart.endpoint, { params: params })
                .then((response) => {
                return response.data;
            });
        });
    }
    static save(param) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isFinite(param.id || 0)) {
                param.id = null;
            }
            return window.axios
                .post(Cart.endpoint, { params: param })
                .then((response) => {
                return response.data;
            });
        });
    }
    static validate(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return window.axios
                .get('/v1/cart/payment/validate/', {
                params: {
                    cartId: cartId
                }
            })
                .then(response => {
                return response.data;
            });
        });
    }
}
Cart.endpoint = '/v1/carts';
